import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M16 4.19a2.93 2.93 0 0 1 2.84 3v8.62a2.93 2.93 0 0 1-2.83 3 2.92 2.92 0 0 1-2.82-3V7.19a2.92 2.92 0 0 1 2.81-3M16 2a5.07 5.07 0 0 0-5 5.16v8.65A5.07 5.07 0 0 0 16 21a5.09 5.09 0 0 0 5-5.16V7.19A5.09 5.09 0 0 0 16 2z"></path><path d="M26 16.38a1 1 0 1 0-1.94 0A7.84 7.84 0 0 1 16 24a7.84 7.84 0 0 1-8-7.62 1 1 0 0 0-1.94 0 9.74 9.74 0 0 0 9 9.52.19.19 0 0 0-.06.1v2h-2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-2a.19.19 0 0 0 0-.07 9.74 9.74 0 0 0 9-9.55z"></path>';
export var MicrophoneOutlineSVG = function MicrophoneOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
MicrophoneOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MicrophoneOutlineSVG);